export default __webpack_public_path__ + "img/oAsxXGqo.1c97a439.svg";